import { useContext } from "react";
import { Button, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import FindGame from "../components/FindGame";
import LocaleContext from "../context/LocaleContext";
import UserContext from "../context/UserContext";

function Home() {
  const user = useContext(UserContext)
  const locale = useContext(LocaleContext)
  const navigate = useNavigate()
  const createGame = () => {
    navigate('/create-game')
  }
  const logout = () => {
    navigate('/')
  }
  return (
    <Form>
      <h3 className="mt-3">{locale.t('Home')}</h3>
      <p>{locale.t('Welcome')}, {user.nickname}. {locale.t('Your balance')}: ${user.balance}</p>
      <FindGame/>
      <div className="d-grid gap-2">
        <Button variant="primary" size="sm" role={"button"} onClick={createGame}>{locale.t('Create game')}</Button>
        <Button variant="secondary" size="sm" role={"button"} onClick={logout}>{locale.t('Logout')}</Button>
      </div>
    </Form>
  )
}

export default Home